import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";

export default function Counter({ to, suffix = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [v, setV] = useState(0);
  const ok = typeof to === "number";

  useEffect(() => {
    if (!ok || !inView) return undefined;
    const c = animate(0, to, { duration: 2, ease: [0.16, 1, 0.3, 1], onUpdate: (x) => setV(Math.round(x)) });
    return () => c.stop();
  }, [to, ok, inView]);

  return <span ref={ref}>{ok ? `${v.toLocaleString()}${suffix}` : "-"}</span>;
}
